/**
 * Sets a wrapped display name on a component.
 * With hooks, display names can be set directly via Component.displayName
 * These utilities are preserved for backward compatibility.
 */
const setWrappedDisplayName = (name) => (WrappedComponent) => {
	const wrappedName =
		WrappedComponent.displayName || WrappedComponent.name || 'Component';
	WrappedComponent.displayName = `${name}(${wrappedName})`;
	return WrappedComponent;
};

export const overwriteDisplayName = (name) => (WrappedComponent) => {
	WrappedComponent.displayName = name;
	return WrappedComponent;
};

export default setWrappedDisplayName;
